
<div class="w-100" >
    <v-row class="no-frame">
        <v-col class="no-frame">
            <div class="v-flex" style="width: 600px">
                <div class="step-sequence primary">
                    {{ step.sequence }}
                </div>
                <div class="pl-2 pt-1 primary--text" style="font-size: 15px">
                    {{ step.step.name }}
                </div>
                <div style="padding-top: 5px; padding-left: 10px; font-size: 15px; ">
                    {{ date (step.beginDate) }} - {{ date (step.endDate) }}
                </div>
                <div style="padding-top: 5px; padding-left: 10px; font-size: 15px; ">
                    {{ step.status.name }}
                </div>
            </div>

        </v-col>
        <v-col class="no-frame pt-1 text-right" >
           <span
               v-if="step.manufacturer"
               class="primary--text"
               style="font-size: 15px"
           >
               {{ step.manufacturer.name }}
           </span>
        </v-col>
    </v-row>

    <div  class="v-flex">
        <div class="w-50">
            <v-row class="no-frame pl-10 mt-2">
                <v-col class="no-frame primary--text" style="font-size: 12px">
                    Komponenten
                </v-col>
            </v-row>

            <div class="lm-border ml-10 pa-2" style="height: calc(100% - 30px)">
                <v-row
                    v-for="(component, index) in step.components "
                    :key="index"
                    class="no-frame w-100 component"
                    :class="selected && (selected.id === component.id) ? 'primary white--text' : ''"
                >
                    <v-col class="no-frame v-flex pl-1 pr-1">
                        <div class="pt-0 component-name" style="width: calc(100% - 85px)">
                            {{ component.name }}
                        </div>
                        <div>
                            <v-icon
                                :color="selected && (selected.id === component.id) ? 'white' : ''"
                            >
                                {{ icon(component) }}
                            </v-icon>
                        </div>
                        <div class="text-right" style="width: 85px">
                            {{ date(component.warrantyDate) }}
                        </div>
                    </v-col>

                </v-row>
            </div>
        </div>

        <div class="w-50 ml-3">
            <div v-if="step.description" >
                <v-row class="no-frame mt-2">
                    <v-col class="no-frame primary--text" style="font-size: 12px">
                        {{ $t('inc.edit.general.description') }}
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pa-2 step-text lm-border" style="min-height: 48px;" v-html="trim (step.description)" />
                </v-row>
            </div>

            <div v-if="step.measure">
                <v-row class="no-frame mt-2">
                    <v-col class="no-frame primary--text" style="font-size: 12px">
                        {{ $t('inc.edit.general.measure') }}
                    </v-col>
                </v-row>
                <v-row class="no-frame h-100" >
                    <v-col class="no-frame pa-2 step-text lm-border h-100" style="min-height: 48px;" v-html="trim (step.measure)" />
                </v-row>
            </div>
        </div>

    </div>
</div>
